export default class EmailUpdate {
    memberId: string;
    emailNotificationInd: boolean;
    email: string;

    constructor(action?) {
    }
  }
